// extracted by mini-css-extract-plugin
export default {"list":"ProgramsPage_list__Nc+H9","card":"ProgramsPage_card__ZHTPv","link":"ProgramsPage_link__Ht8Tx","title":"ProgramsPage_title__lgl3+","image":"ProgramsPage_image__FybBg"};